import { collection, getDocs, setDoc, updateDoc, doc, deleteDoc, orderBy, query, where } from 'firebase/firestore';
import { db } from '../../firebase_config';
import { BOARD_COLLECTION, Board } from '../../type';

class BoardService {
  async getAll(): Promise<Board[]> {
    const q = query(collection(db, BOARD_COLLECTION), orderBy('createdAt', 'desc'));
    const snapshot = await getDocs(q);

    return snapshot.docs.map(doc => ({ 
      ...doc.data(),
      boardId: doc.id 
    } as Board));
  }

  async create(board: Board): Promise<void> {
    await setDoc(doc(db, BOARD_COLLECTION, board.boardId), board);
  }

  async update(boardId: string, board: Partial<Board>): Promise<void> {
    const { boardId: _, ...boardData } = board;
    await updateDoc(doc(db, BOARD_COLLECTION, boardId), boardData);
  }

  async delete(boardId: string): Promise<void> {
    await deleteDoc(doc(db, BOARD_COLLECTION, boardId));
  }
}

export const boardService = new BoardService();